import React from 'react'
import Text from '../../Text'
import { $layer2, $textPrimary } from '../../../styles/colors/semantics'
import styles from './styles.module.css'

function FreeShippingTag({ show }) {
  return (
    <div
      className={[styles.tag, show ? styles.shown : styles.hidden].join(' ')}
      style={{ background: $layer2.light, color: $textPrimary.light }}
    >
      <Text type="tiny">Free shipping</Text>
    </div>
  )
}

export default FreeShippingTag
